export class EstadoPlanilla {
  idestado?: number;
  codigo?: string;
  nombre?: string;
  orden?: number;
  es_final?: boolean;
  editando?: boolean;
  constructor() { this.orden = 0; this.es_final = false; }
}
